/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize AppointmentsSchedule View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AppointmentsScheduleView';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsAppointmentsScheduleView = mapStateToProps;
export const mapDispatchToPropsAppointmentsScheduleView = mapDispatchToProps;

export default connect(
  mapStateToPropsAppointmentsScheduleView,
  mapDispatchToPropsAppointmentsScheduleView
)(View);
